import { Check } from 'lucide-react'

import type { RenderLink } from '@ui/web/utils'
import { Button } from '@ui/web/components'
import { getStaticAssetUrl } from '@helper/utils/file'
import cn from '@config/tailwind/cn'

interface LockFeatureProps {
  className?: string
  featureText: string
  renderLink: RenderLink
}

export function LockFeature({ className, featureText, renderLink }: LockFeatureProps) {
  return (
    <div className={cn('srd:mt-16 srd:mb-10 srd:h-fit srd:w-full srd:max-w-[650px]', className)}>
      <div className='srd:bg-complementary-yellow-10 srd:absolute srd:top-0 srd:left-1/2 srd:h-fit srd:w-fit srd:-translate-x-1/2 srd:rounded-full srd:p-2'>
        <img
          src={getStaticAssetUrl('illustration/bintang-senyum.svg')}
          alt=''
          width={40}
          height={40}
          draggable={false}
        />
      </div>

      <div className='srd:-mt-6 srd:flex srd:w-full srd:flex-col srd:items-center srd:justify-center srd:gap-y-10'>
        <div className='srd:w-full srd:overflow-clip srd:rounded-2xl'>
          <div className='srd:bg-complementary-purple-100 srd:h-[30px] srd:w-full' />

          <div className='srd:from-neutrals-white srd:via-neutrals-white srd:to-main-blue-20 srd:flex srd:flex-col srd:gap-y-8 srd:bg-linear-to-b srd:p-6'>
            <header className='srd:flex srd:w-full srd:flex-col srd:items-center srd:justify-center srd:gap-y-2 srd:text-center'>
              <h6 className='srd:text-sm srd:font-medium'>Fitur khusus</h6>
              <h5 className='srd:text-complementary-purple-100 srd:text-2xl srd:font-bold srd:md:text-3xl'>
                Sekolah premium
              </h5>
            </header>

            <ul className='srd:flex srd:flex-col srd:gap-y-3'>
              <li className='srd:flex srd:items-center srd:gap-x-2'>
                <Check className='srd:text-main-red-100' />
                <p>Beri murid akses perpustakaan tanpa batas dengan Kursi Premium</p>
              </li>

              <li className='srd:flex srd:items-center srd:gap-x-2'>
                <Check className='srd:text-main-red-100' />
                <p>Akses modul belajar keterampilan literasi tanpa batas</p>
              </li>

              <li className='srd:flex srd:items-center srd:gap-x-2'>
                <Check className='srd:text-main-red-100' />
                <p>Kelola kelas untuk memudahkan pengajaran</p>
              </li>

              <li className='srd:flex srd:items-center srd:gap-x-2'>
                <Check className='srd:text-main-red-100' />
                <p>Berkolaborasi dengan guru lain untuk mengajar bersama</p>
              </li>

              <li className='srd:flex srd:items-center srd:gap-x-2'>
                <Check className='srd:text-main-red-100' />
                <p>Bergabung dengan Komunitas Guru Literasi PiBo</p>
              </li>

              <li className='srd:flex srd:items-center srd:gap-x-2'>
                <Check className='srd:text-main-red-100' />
                <p>Dapatkan pelatihan dan dukungan prioritas</p>
              </li>
            </ul>
          </div>
        </div>

        <p className='srd:text-center srd:text-2xl srd:font-bold srd:md:text-3xl'>{featureText}</p>

        <div className='srd:flex srd:flex-col srd:items-center srd:justify-center srd:gap-y-2 srd:text-center'>
          <p className='srd:text-semibold srd:bg-complementary-purple-20 srd:text-complementary-purple-100 srd:rounded-lg srd:px-2 srd:py-1'>
            Mulai dari Rp19.500 / bulan setiap murid
          </p>

          <p className='srd:text-xs'>Tanpa perpanjang otomatis, perbarui kapan saja</p>
        </div>

        <Button variant='gradient'>{renderLink({ children: 'Tingkatkan ke Premium' })}</Button>
      </div>
    </div>
  )
}
